const FARE_VISUALIZATION_TYPES = {
  /**
   * Платон
   */
  platon: 1,
  /**
   * Платная дорога
   */
  toll: 2,
  /**
   * Обычная дорога
   */
  common: 4,
  /**
   * Машина без груза
   */
  emptyTruck: 8
};
Object.freeze(FARE_VISUALIZATION_TYPES);

export default FARE_VISUALIZATION_TYPES;
